import React from "react";
import classnames from "classnames/bind";

import CabinetButton from "./components/CabinetButton";
import LogoutButton from "./components/LogoutButton";
import LicensesBlock from "./components/LicensesBlock";
import Balance from "./components/Balance";

import styles from "./ProfileDropdown.scss";

const cx = classnames.bind(styles);

const ProfileDropdown = () => (
  <div className={cx("profile-dropdown")}>
    <CabinetButton />
    <Balance />
    <LicensesBlock />
    <div className={cx("divider")} />
    <LogoutButton />
  </div>
);

export default ProfileDropdown;
